import Vue from 'vue'
import noty from '@/plugins/noty'
import EventBus from '@/lib/event-bus'
import store from '@/store'
import lstore from '@/lib/store'
import { jiminnyHost } from '@/helpers/region'
import VueComponentsPlugin from 'vue-components'
import pipedriveLogo from '@/assets/img/pipedrive.png'
import copperLogo from '@/assets/img/copper.png'
import closeLogo from '@/assets/img/close.svg'
import bullhornLogo from '@/assets/img/bullhorn.svg'

Vue.use(VueComponentsPlugin, {
  store,
  noty,
  EventBus,
  jiminnyHost,
  pipedriveLogoUrl: pipedriveLogo,
  copperLogoUrl: copperLogo,
  closeLogoUrl: closeLogo,
  bullhornLogoUrl: bullhornLogo,
  getTeam () {
    return lstore.get('team')
  },
  getUserId () {
    return lstore.get('user').id
  },
  hostApp: 'extension-app'
})



// WEBPACK FOOTER //
// ./src/plugins/vue-components.js